export enum DocumentTypeCatagories {
  staff,
  student,
  poeGeneral,
  poeWorkplace,
  poeAssessmentGuide,
  poeGroupGeneral,
  poeFormativeAssessment,
  poeSummativeAssessment,
  organizational,
  generalQualAndLearnership
}
